import React, { Component } from "react";
import CustomBoardRenewal from "../../../../components/CustomBoardRenewal";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../../components/CustomText";
import Grid from "@material-ui/core/Grid";
import CustomButton from "../../../../components/CustomButton";
import { connect } from "react-redux";
import * as selector from "../../../../../common/selectors";
import * as policyAction from "../../../../../common/actions/policy";
import * as onlineRenewalAction from "../../../../../common/actions/onlineRenewal";
import _ from "lodash";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import ReactHtmlParser from "react-html-parser";
import * as onlineRenewalSelector from "../../../../../common/selectors/onlineRenewal";
import Image from "../../../../../assets";
import CarouselBanner from "../CarouselBanner";
import ReactGA from "react-ga";

const PAYMENT_SUCCESS = "7";
const PAYMENT_FAILURE = "8";

class PaymentStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
      width: 0,
      paymentStatus: null,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    const { getStatusMessage } = this.props;
    const { search } = this.props.location;
    const params = new URLSearchParams(search);
    const Id = params.get("orderNumber");

    var q = this.getUrlVars()["orderNumber"];
    this.setState({ paymentStatus: q });

    getStatusMessage(q);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  getUrlVars = () => {
    var vars = {};
    var parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        vars[key] = value;
      }
    );
    return vars;
  };

  onClickRetryRenewal = () => {
    ReactGA.event({
      category: 'RenewalPages',
      action: 'Retry Renewal'
    });
    const { history } = this.props;
    history.push("/OnlineRenewal");
  };

  strip_html_tags = (str) => {
    if (str === null || str === "") return false;
    else str = str.toString();
    return str.replace(/<[^>]*>/g, "");
  };

  onClickTakeSurvey = () => {
    ReactGA.event({
      category: 'RenewalPages',
      action: 'Taking Survey'
    });
    const statusData = onlineRenewalSelector.getStatusMsgDataData(
      this.props.getStatusMsgData
    );
    const statusMessageCode = onlineRenewalSelector.getStatusMsgDataStatusMessage(
      statusData
    );
    const statusSurveyLink = onlineRenewalSelector.getStatusMsgDataSurveyLink(
      statusData
    );
    window.open(statusSurveyLink);
  };

  onClickBanner = () => {
    ReactGA.event({
      category: 'RenewalPages',
      action: 'Banner Clicking'
    });
    window.location.href = "https://www.tiq.com.sg/buy-online/3-plus-critical-illness/quotation/?promoCode=3PLUSTIQ50%20&utm_source=internal&utm_medium=email&utm_campaign=Tiq+May2022+3PlusCI+EDM+Renewal";
  }

  renderChildren = () => {
    const {
      classes,
      paymentStatusMessage,
      getStatusMsgData,
      getStatusMsgStatus,
      getStatusMsgLoading,
    } = this.props;
    const { paymentStatus } = this.state;
    var a = this.strip_html_tags(getStatusMsgData);
    a.toString();
    var b = a.toString();
    var c = b.substr(0, 58);
    var d = b.substr(58, 88);
    var e = b.substr(146, 54);
    var f = b.substr(174, 121);
    var g = b.substr(298, 120);
    var h = b.substr(430, 79);
    const status = onlineRenewalSelector.getStatusMsgDataStatus(
      getStatusMsgData
    );
    const success = onlineRenewalSelector.getStatusMsgDataSuccess(
      getStatusMsgData
    );

    const statusData = onlineRenewalSelector.getStatusMsgDataData(
      getStatusMsgData
    );
    const statusMessageCode = onlineRenewalSelector.getStatusMsgDataStatusMessage(
      statusData
    );
    const statusLabel = onlineRenewalSelector.getStatusMsgDataLabel(statusData);
    const loginPortalLink = onlineRenewalSelector.getStatusMsgDataLoginPortalLink(
      statusData
    );
    const statusEmail = onlineRenewalSelector.getStatusMsgDataEmail(statusData);

    const statusMobile = onlineRenewalSelector.getStatusMsgDataMobile(
      statusData
    );

    return (
      <div>
        {getStatusMsgData !== (null || undefined || "") &&
          getStatusMsgLoading === false &&
          getStatusMsgStatus === true ? (
          status === "OK" && success === true ? (
            <Grid container direction={"column"} spacing={3}>
              <Grid item>
                <CustomText
                  design={classes.renewNowTextStyle}
                  style={{ color: "#2c3034" }}
                >
                  {statusLabel}
                </CustomText>
              </Grid>
              {statusMessageCode === 1 ? (
                <Grid item>
                  <Grid container direction={"column"} spacing={3}>
                    <Grid item>
                      <CustomText design={classes.textStyle}>
                        Thank you for renewing your policy with us.
                      </CustomText>
                      <CustomText design={classes.textStyle}>
                        Your request will be processed within 3-5 business days.
                      </CustomText>
                      <CustomText design={classes.textStyle}>
                        Tell us how your renewal experience went in this short
                        survey.
                      </CustomText>
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                false
              )}

              {statusMessageCode === 2 ? (
                <Grid item>
                  <Grid container direction={"column"} spacing={3}>
                    <Grid item>
                      <CustomText design={classes.textStyle}>
                        Thank you! Your payment is successful.
                      </CustomText>
                      <CustomText design={classes.textStyle}>
                        We noticed that you do not have an email or mobile
                        number registered with us, please Whatsapp our Customer
                        Service at +65{" "}
                        <b>
                          <u>6</u>
                        </b>
                        887 8777 so that you can view your policy documents on
                        our{" "}
                        <a
                          href={loginPortalLink}
                          target="blank"
                          style={{ fontWeight: "bold" }}
                        >
                          <u>Online Portal </u>
                        </a>
                        .
                      </CustomText>
                      <CustomText design={classes.textStyle}>
                        Tell us how your renewal experience went in this short
                        survey.
                      </CustomText>
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                false
              )}

              {statusMessageCode === 3 ? (
                <Grid item>
                  <Grid container direction={"column"} spacing={3}>
                    <Grid item>
                      <CustomText design={classes.textStyle}>
                        Thank you! Your payment is successful.
                      </CustomText>
                      <CustomText design={classes.textStyle}>
                        A confirmation will be sent to:
                      </CustomText>
                      <CustomText design={classes.textStyle}>
                        Mobile: {statusMobile}
                      </CustomText>
                      <CustomText design={classes.textStyle}>
                        Email: {statusEmail}
                      </CustomText>
                      <CustomText design={classes.textStyle}>
                        If you need to update your contact information, Whatsapp
                        our Customer Service at +65{" "}
                        <b>
                          <u>6</u>
                        </b>
                        887 8777. <br />
                        <br />
                      </CustomText>
                      <CustomText design={classes.textStyle}>
                        Your policy documents will be available to view on our{" "}
                        <a
                          href={loginPortalLink}
                          target="blank"
                          style={{ fontWeight: "bold" }}
                        >
                          <u>Online Portal </u>
                        </a>
                        by the next working day.
                      </CustomText>
                      <CustomText design={classes.textStyle}>
                        Tell us how your renewal experience went in this short
                        survey.
                      </CustomText>
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                false
              )}

              {statusMessageCode === 4 ? (
                <Grid item>
                  <Grid container direction={"column"} spacing={3}>
                    <Grid item>
                      <CustomText design={classes.textStyle}>
                        Your payment is not successful.
                      </CustomText>
                      <CustomText design={classes.textStyle}>
                        Please try again.
                      </CustomText>
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                false
              )}

              {statusMessageCode === 5 ? (
                <Grid item>
                  <Grid container direction={"column"} spacing={3}>
                    <Grid item>
                      <CustomText design={classes.textStyle}>
                        Sorry, we are unable to process your renewal.
                      </CustomText>
                      <CustomText design={classes.textStyle}>
                        Please Whatsapp our Customer Care Consultants at +65
                        6887 8777.(Mondays to Fridays, 8.45am to 5.30pm. We are
                        closed on Saturdays, Sundays and Public Holidays.)
                      </CustomText>
                      <CustomText design={classes.textStyle}>
                        Thank you.
                      </CustomText>
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                false
              )}

              {statusMessageCode === 6 ? (
                <Grid item>
                  <Grid container direction={"column"} spacing={3}>
                    <Grid item>
                      {/* <CustomText design={classes.textStyle}>
                 Payment Processing
                </CustomText> */}
                      <CustomText design={classes.textStyle}>
                        Your payment is being processed.
                      </CustomText>
                      <CustomText design={classes.textStyle}>
                        You'll receive a confirmation email once it's successful.
                      </CustomText>
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                false
              )}

              {statusMessageCode === 1 ? (
                <Grid item>
                  <CustomButton
                    title={"Take Survey"}
                    design={classes.retryRenewalButton}
                    textstyle={classes.buttonTextStyle}
                    onClick={this.onClickTakeSurvey}
                  />
                </Grid>
              ) : (
                false
              )}


              {statusMessageCode === 2 ? (
                <Grid item>
                  <CustomButton
                    title={"Take Survey"}
                    design={classes.retryRenewalButton}
                    textstyle={classes.buttonTextStyle}
                    onClick={this.onClickTakeSurvey}
                  />
                </Grid>
              ) : (
                false
              )}

              {statusMessageCode === 3 ? (
                <Grid item>
                  <CustomButton
                    title={"Take Survey"}
                    design={classes.retryRenewalButton}
                    textstyle={classes.buttonTextStyle}
                    onClick={this.onClickTakeSurvey}
                  />
                </Grid>
              ) : (
                false
              )}

              {/* {statusMessageCode === 3 && window.innerWidth > 600 ? (
                <Grid item xs={12}>
              <img
                src={
                  "https://www.tiq.com.sg/wp-content/uploads/2022/05/3-plus-banner2.jpg"
                }
                style={{ width: 400, height: 220,marginTop:5 ,cursor:"pointer"}}
                onClick={this.onClickBanner}
              />
            </Grid>
              ) : (
                false
              )} */}

              {/* {statusMessageCode === 3 && window.innerWidth > 600 ? (
                <Grid item xs={12}>
              <img
                src={
                  "https://www.tiq.com.sg/wp-content/uploads/2022/05/3-plus-banner2.jpg"
                }
                style={{ width: 400, height: 220,marginTop:5 ,cursor:"pointer"}}
                onClick={this.onClickBanner}
              />
            </Grid>
              ) : (
                false
              )} */}


              {/* <Grid item xs={12}>
              <img
                src={
                  "https://www.tiq.com.sg/wp-content/uploads/2022/05/3-plus-banner2.jpg"
                }
                style={{ width: window.innerWidth - "1em", height: 170,marginTop:5,cursor:"pointer" }}
                onClick={this.onClickBanner}
              />
            </Grid> */}


              {/* <CarouselBanner/> */}

              {statusMessageCode === 4 ? (
                <Grid item>
                  <CustomButton
                    title={"Retry Renewal"}
                    design={classes.retryRenewalButton}
                    textstyle={classes.buttonTextStyle}
                    onClick={this.onClickRetryRenewal}
                  />
                </Grid>
              ) : (
                false
              )}
              {statusMessageCode === 5 ? (
                <Grid item>
                  <CustomButton
                    title={"Retry Renewal"}
                    design={classes.retryRenewalButton}
                    textstyle={classes.buttonTextStyle}
                    onClick={this.onClickRetryRenewal}
                  />
                </Grid>
              ) : (
                false
              )}
            </Grid>
          ) : (
            <Grid container direction={"column"} spacing={3}>
              <Grid item>
                <CustomText
                  design={classes.renewNowTextStyle}
                  style={{ color: "#2c3034" }}
                >
                  Renewal Unsuccessful
                </CustomText>
              </Grid>

              <Grid item>
                <CustomText>Your payment is not successful.</CustomText>
              </Grid>

              <Grid item>
                <CustomText>Please Try Again.</CustomText>
              </Grid>

              <Grid item>
                <CustomButton
                  title={"Retry Renewal"}
                  design={classes.retryRenewalButton}
                  textstyle={classes.buttonTextStyle}
                  onClick={this.onClickRetryRenewal}
                />
              </Grid>
            </Grid>
          )
        ) : (
          false
        )}
      </div>
    );
  };

  render() {
    const {
      classes,
      getStatusMsgLoading,
      paymentStatusMessageLoading,
    } = this.props;
    const { height, width } = this.state;

    return (
      <div className={classes.root}>
        <CustomBoardRenewal
          children={this.renderChildren()}
          height={window.innerWidth < 600 ? height + 200 : height + 30}
          width={width}
        />

        {getStatusMsgLoading ? <LoadingOverlay loading={true} /> : false}
        {paymentStatusMessageLoading ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  checkButtonStyle: {
    height: 40,
    fullWidth: true,
    marginTop: 10,
  },
  buttonTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("medium"),
  },
  renewNowTextStyle: {
    ...getFontWeight("800"),
    fontSize: 28,
    textAlign: "left",
    color: "#2c3034",
    marginBottom: 10,
  },
  retryRenewalButton: {
    width: 160,
    marginTop: 10,
  },
  textStyle: {
    marginBottom: 10,
  },
});

function mapStateToProps(state) {
  return {
    paymentStatusMessage: selector.getPaymentStatusMessage(state),
    paymentStatusMessageLoading: selector.getPaymentStatusMessageLoading(state),
    getStatusMsgData: selector.getStatusMsgData(state),
    getStatusMsgLoading: selector.getStatusMsgLoading(state),
    getStatusMsgStatus: selector.getStatusMsgStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getPaymentStatusMessage: (Id) =>
      dispatch(policyAction.getPaymentStatusMessageRequest(Id)),
    getStatusMessage: (orderNo) =>
      dispatch(onlineRenewalAction.getStatusMessage(orderNo)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(PaymentStatus)));
